import type {KeyValoreStrNum} from "@/app/data/DataTypes";

export class TestoResult {

    public testo: KeyValoreStrNum[] = [];

    constructor(json: any = null) {
        if (json && json.data && json.data.pgQuery && json.data.pgQuery.list && json.data.pgQuery.list.length > 0 && json.data.pgQuery.list[0].result) {
            this.testo = json.data.pgQuery.list[0].result;
        }
    }
}